// @ts-nocheck
import { useEffect } from "react";

/**
 * Prevents the user from accidentally leaving the page (e.g. closing the tab)
 * when `when` is true. Only uses the browser's beforeunload prompt.
 *
 * In-app navigation (sidebar, Links, navigate()) is intentionally NOT blocked.
 * Blocking navigator.push caused a bug where the first click to navigate did
 * nothing (same URL) and the user had to click again.
 */
export function usePreventExit(when = true, _whitelist: string[] = []) {
  useEffect(() => {
    if (when) {
      window.onbeforeunload = function (event) {
        event.preventDefault();
        event.returnValue = "";
      };
    }

    return () => {
      window.onbeforeunload = null;
    };
  }, [when]);
}
